import { render, staticRenderFns } from "./AlertDeleteForm.vue?vue&type=template&id=07809567&scoped=true&"
import script from "./AlertDeleteForm.vue?vue&type=script&lang=ts&"
export * from "./AlertDeleteForm.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDeleteForm.vue?vue&type=style&index=0&id=07809567&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07809567",
  null
  
)

export default component.exports